<template>
    <div class="index-wrap">
        <div class="firstTechClass">
            <div class="wordClassTwoMain">技&nbsp;术&nbsp;实&nbsp;力</div>
            <div class="wordClassTwoMainChild">运动科技改变体育教育</div>
        </div>
        <div class="secondTechClass">
            <div style="position: absolute;height: 480px;width: 1200px;transform: translate(-50%, -50%);top: 50%;left:50%;">
                <div style="position: relative;height: 184px;width: 695px;transform: translate(-50%, -50%);top: 10%;left: 50%;text-align: center">
                    <div style="left:50%;top:18%;width: 430px;transform: translate(-50%, -50%);position: absolute;font-size: 48px;font-family: Source Han Sans CN;font-weight: bold;color: #FF4B4B;">
                        2023年满分运动
                    </div>
                    <div style="left:50%;top:60%;width: 600px;transform: translate(-50%, -50%);position: absolute;font-size: 48px;font-family: Source Han Sans CN;font-weight: bold;color: #FF4B4B;">
                        入库国家级科技型中小企业
                    </div>
                    <img src="../assets/pageTwo/leftImg.png" style="" align="left">
                    <img src="../assets/pageTwo/rightImg.png" style="" align="right">
                </div>
                <div>
                    <img align="center" src="../assets/pageTwo/certificateImg.png" style="height: 285px;">
                </div>
                <br/>
                <br/>
                <div>
                    <img src="../assets/pageTwo/backThree.png" style="margin: 0 auto;display: block">
                </div>
            </div>
        </div>
        <div style="position: relative">
            <!--            <div style="width: 100%;height: 230px;background: #42b983"></div>-->
            <div style="width: 36.5%;height: 694px;background: #FFFFFF;position: relative;float: left;">
                <div style="height: 262px;width: 355px;position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);">
                    <img align="center" src="../assets/pageTwo/logoOne.png" style="height: 40px;position: absolute;">
                    <img align="center" src="../assets/pageTwo/logoAnd.png"
                         style="height: 68px;position: absolute;top: 93px;left: 147px;">
                    <img align="center" src="../assets/pageTwo/logoTwo.png"
                         style="height: 58px;position: absolute;top: 200px">
                </div>
            </div>

            <div class="technologyClassOne" style="position: relative;float: right;width: 63.5%;height: 694px;">
                <div style="height: 580px;width: 748px;position: absolute;top: 50%;left:50%;transform: translate(-50%, -50%);">
                    <img align="center" src="../assets/pageTwo/uniteLogo.png"
                         style="position: absolute;left: 112px;top: 9px;">
                    <div style="font-size: 18px;font-family:Source Han Sans CN;font-weight: 400;color: #4C4C4C;line-height: 28px;margin-top:119px">
                        满分运动与北京大学信息技术高等研究院联合设立运动科技与健康大数据实验室。实验室下设运动健康大数据分析、智能教育SaaS系统及AI应用研发、智能运动硬件研发制造、体教创新人才培养、运动课程数字化等五大中心，聚集了“教育+体育+信息技术”最领先行业人才，坚持将理论与实践相结合，技术开发与落地转化并重，为中国青少年科学运动、健康成长、综合发展提供信息化支撑。
                    </div>
                    <img align="center" src="../assets/pageTwo/character.png"
                         style="position: absolute;bottom: -19px;left: 79px;">
                    <div style="top: 208px;font-size: 32px;font-family: Alibaba PuHuiTi;font-weight: bold;color: rgb(34, 34, 34);position: relative;left: 386px;">
                        周寅猛
                        <div style="font-size: 18px;position: absolute;top: 13px;left: 104px;">博士</div>
                        <div style="font-size: 18px;position: absolute;top: 57px;font-weight: 400;font-family:Source Han Sans CN;line-height: 24px;color: rgb(76, 76, 76);width: 346px;">
                            北京大学运动科技与健康大数据实验室主任由满分运动创始人周寅猛博士担任
                        </div>
                    </div>
                    <div class="wordClassTwoLeftLine"></div>
                </div>
            </div>
        </div>

        <div class="matrixClass" style="display:flex;justify-content: center; align-items:center;">
            <div class="wordClassTwoChild">满分科技产品矩阵</div>
            <div class="wordClassTwoChildLine"></div>
            <div style="height: 200px;clear: both;position: absolute"></div>
            <div style="position: absolute;width: 1500px;height: 1700px;top: 10%;">
                <!--                中间-->
                <div style="position: absolute;top: 750px;left:50%;transform: translate(-50%, -50%);">
                    <img src="../assets/matrixImg/center.png" style="height: 800px">
                </div>
                <!--左上-->
                <div style="height:800px;position: absolute;top: 384px;left:452px;transform: translate(-50%, -50%);"
                     data-wow-duration="2s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/leftUpOne.png" style="height: 558px;margin-top: 197px">
                </div>
                <div style="position: absolute;top: 393px;left:385px;transform: translate(-50%, -50%);"
                     data-wow-duration="6s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/leftUpTwo.png" style="height: 693px">
                </div>
                <!--右上-->
                <div style="height:800px;position: absolute;top: 384px;left:1048px;transform: translate(-50%, -50%);"
                     data-wow-duration="2s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/rightUpOne.png" style="height: 558px;margin-top: 197px">
                </div>
                <div style="position: absolute;top: 393px;left:1115px;transform: translate(-50%, -50%);"
                     data-wow-duration="6s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/rightUpTwo.png" style="height: 693px">
                </div>
                <!--左下-->
                <div style="position: absolute;top: 1039px;left:452px;transform: translate(-50%, -50%);"
                     data-wow-duration="2s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/leftDownOne.png" style="height: 557px;">
                </div>
                <div style="position: absolute;top: 1106px;left:385px;transform: translate(-50%, -50%);"
                     data-wow-duration="6s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/leftDownTwo.png" style="height: 693px">
                </div>
                <!--右下-->
                <div style="height:800px;position: absolute;top: 1160px;left:1048px;transform: translate(-50%, -50%);"
                     data-wow-duration="2s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/rightDownOne.png" style="height: 558px;">
                </div>
                <div style="position: absolute;top: 1106px;left:1115px;transform: translate(-50%, -50%);"
                     data-wow-duration="6s" class="wow animate__animated animate__fadeIn">
                    <img src="../assets/matrixImg/rightDownTwo.png" style="height: 693px">
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        mounted() {
            if(!this._isMobile()){//pc端显示动画
                new this.$wow.WOW().init();
            }
        },
        data() {
            return {}
        },
        methods: {
            // 判断是否是手机端，如果是，返回true
            _isMobile () {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag
            }
        }
    }
</script>

<style scoped>
    .matrixClass {
        background-image: url('../assets/pageTwo/backFour.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 100%;
        height: 1700px;
        position: relative;
        clear: both;
    }

    .firstTechClass {
        position: relative;
        width: 100%;
        height: 625px;
        min-width: 500px;
        background-image: url('../assets/pageTwo/mainBack.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }

    .secondTechClass {
        position: relative;
        width: 100%;
        height: 700px;
        min-width: 500px;
        background-image: url('../assets/pageTwo/backOne.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
    }


    .wordClassTwoChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 100px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 48px;
        font-weight: bold;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #222222;
        line-height: 18px;
        clear: both;
    }

    .wordClassTwoMain {
        position: absolute; /* 设置绝对定位子元素 */
        top: 226px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 78px;
        font-weight: 800;
        /*font-family: Source Han Sans CN;*/
        font-family: 'heavy';
        color: #FFFFFF;
    }

    .wordClassTwoMainChild {
        position: absolute; /* 设置绝对定位子元素 */
        top: 360px; /* 将子元素底部与父元素底部对齐 */
        width: 100%; /* 设置子元素宽度为父元素宽度 */
        text-align: center; /* 设置子元素文本居中 */
        font-size: 37px;
        font-weight: 400;
        font-family: Source Han Sans CN;
        color: #FFFFFF;
    }

    .wordClassTwoChildLine {
        position: absolute; /* 设置绝对定位子元素 */
        top: 160px; /* 将子元素底部与父元素底部对齐 */
        height: 4px;
        width: 79px;
        transform: translate(-50%, -50%);
        left: 50%;
        background: #F8DB00;
        clear: both;
    }

    .wordClassTwoLeftLine {
        position: absolute; /* 设置绝对定位子元素 */
        height: 4px;
        width: 79px;
        transform: translate(-50%, -50%);
        left: 50%;
        background: #F8DB00;
        top: -8px;
    }


    .technologyClassOne {
        background-image: url('../assets/pageTwo/backTwo.png');
        background-size: 100% 100%;
    }


</style>

<style scoped>
    .index-wrap {
        width: 100%;
        height: auto;
        overflow: hidden;
        position: relative;
    }

    .index-left-block h2 {
        background: #4fc08d;
        color: #fff;
        padding: 10px 15px;
        margin-bottom: 20px;
    }

    .index-left-block h3 {
        padding: 0 15px 5px 15px;
        font-weight: bold;
        color: #222;
    }

    .index-left-block ul {
        padding: 10px 15px;
    }

    .index-left-block li {
        padding: 5px;
    }


    .index-board-item h2 {
        font-size: 18px;
        font-weight: bold;
        color: #000;
        margin-bottom: 15px;
    }

    .VueCarousel-slide img {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/pages/technology.vue